import { useKestrel } from 'features/kestrelViewer'
import { GenericEditButton } from 'features/kestrelViewer/kestrelViewerMarkup/utils/GenericEditButton'
import React, { FC } from 'react'
import { Vector2 } from 'three'
import { KVInspectionArea } from 'types'

export const EditInspectionAreaButton: FC<{
  inspectionArea: KVInspectionArea
}> = ({ inspectionArea }) => {
  const { setPopupMenuStartPosition, setSelectedMarkup } = useKestrel()

  const handleEdit = () => {
    if (setPopupMenuStartPosition) {
      setPopupMenuStartPosition(new Vector2(80, 20))
    }
    setSelectedMarkup(inspectionArea)
  }

  return (
    <GenericEditButton
      itemId={inspectionArea.id}
      tooltipLabel='Edit inspection area'
      onEdit={handleEdit}
    />
  )
}
